import type * as React from 'react';
import { useEffect, useState } from 'react';
import { useFragment } from 'react-relay';
import { Tranche } from '../tranche';
import { fundFragment } from './Fund.relay';
import type { FundPropsType } from './types';

const Fund: React.FC<FundPropsType> = (props) => {
  const fund = useFragment(fundFragment, props.fund);

  const [isExpanded, setIsExpanded] = useState(false);

  useEffect(() => {
    if (typeof props.resolveFund === 'function') {
      props.resolveFund(() => fund);
    }
  }, [props.resolveFund, fund]);

  const expand = (): void => {
    setIsExpanded((prev) => !prev);
  };

  const fundProps = {
    fundsname: fund.fundsname,
    category: fund.category,
    distribution: fund.distribution,
    currency: fund.currency,
    largeinvestmentfonds: fund.largeinvestmentfonds,
    traits: fund.traits,
  };

  const tranches = props.filterFn(fund.tranches.edges, fund);
  const trancheCount = tranches.length;

  const expanded = tranches.length > 1 ? isExpanded : false;
  const isExpandable = trancheCount > 1;

  return (
    <tbody
      className={`Fund ${isExpandable ? 'Fund-isExpandable' : ''} ${expanded ? 'Fund-expanded' : 'Fund-collapsed'} first:[&>tr:first-child>td]:pt-3 ${isExpandable ? '[&_.Tranche>td:first-child]:cursor-pointer' : ''} ${expanded ? 'bg-[#fbfbfb] [&_.Tranche>td]:bg-[#fbfbfb] [&_.Tranche:not(:last-child)>td:first-child]:border-b-0 [&_.Tranche:not(:last-child)>td:not(:first-child)]:border-b-dashed max-[620px]:[&_.Tranche:not(:last-child)>td:not(:first-child)]:border-b-0' : ''}`}
    >
      {tranches
        .slice(0, expanded ? trancheCount : 1)
        .sort(props.sortFn)
        .map((trancheRow, idx) => {
          return (
            <Tranche
              key={trancheRow.node.id}
              expandFn={() => trancheCount > 1 && expand()}
              tranche={trancheRow.node}
              fund={fundProps}
              trancheCount={trancheCount}
              isFirst={idx === 0}
              isExpanded={expanded || trancheCount === 1}
              salesAdmission={props.salesAdmission}
              liveFilterInfo={props.liveFilterInfo}
              detailFilterInfo={props.detailFilterInfo}
              detailFilterVisible={props.detailFilterVisible}
              location={props.location}
            />
          );
        })}
    </tbody>
  );
};

export { Fund };
